module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "crousel-container mt-1"
  }, [_c('carousel', {
    ref: "my-carousel",
    class: _vm.isDesktop ? 'bannerview' : 'mobileBannerView',
    attrs: {
      "navigationEnabled": _vm.isDesktop,
      "paginationEnabled": true,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": false,
      "loop": true,
      "speed": 500,
      "perPage": 1,
      "paginationPadding": _vm.isDesktop ? 6 : 2,
      "paginationSize": 6,
      "paginationPosition": 'bottom'
    }
  }, _vm._l((_vm.banners.mobile), function(bannerImage, index2) {
    return _c('slide', {
      key: index2
    }, [_c('a', {
      staticClass: "d-inline-block w-100",
      attrs: {
        "href": bannerImage.image_redirect_link
      }
    }, [_c('img', {
      staticClass: "img-auto",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": bannerImage.image,
        "width": "1500",
        "height": "385"
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "corusel-description"
  }, [_c('span', [_vm._v(_vm._s(_vm.allData.main_content_2_disclaimer))])]), _vm._v(" "), _c('div', {
    staticClass: "corusel-btn mt-3"
  }, [_c('a', {
    attrs: {
      "href": _vm.allData && _vm.allData.page_header_button_redirect_link
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.allData.page_header_button_text || 'EXPLORE'))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "gallry-1 mt-3"
  }, [_c('div', {
    staticClass: "fullwidth-img row"
  }, _vm._l((_vm.gallaryImages[_vm.isDesktop ? 'desktop' : 'mobile'].fullWidthImg), function(img, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-12"
    }, [_c('a', {
      staticClass: "d-inline-block w-100",
      attrs: {
        "href": img.imgNavigateLink || '#'
      },
      on: {
        "click": function($event) {
          _vm.preventEmptyLink(img.imgNavigateLink)
        }
      }
    }, [_c('img', {
      staticClass: "img-auto",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": ((img.imgLink) + "?t=" + (new Date().getTime())),
        "width": "1500",
        "height": "385"
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "halfWidth-img",
    class: _vm.isDesktop ? 'mt-4 mx-3' : 'mt-3 mx-3'
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.gallaryImages[_vm.isDesktop ? 'desktop' : 'mobile'].halfWidthImg), function(img, index) {
    return _c('div', {
      key: index,
      staticClass: "col-6"
    }, [_c('a', {
      attrs: {
        "href": img.imgNavigateLink || '#'
      },
      on: {
        "click": function($event) {
          _vm.preventEmptyLink(img.imgNavigateLink)
        }
      }
    }, [_c('img', {
      staticClass: "img-half-width",
      attrs: {
        "src": ((img.imgLink) + "?t=" + (new Date().getTime()))
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "img-description"
    }, [_c('p', [_vm._v(_vm._s(img.imgDescription))])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "media-conatiner mt-3",
    class: _vm.isDesktop ? 'mt-5' : 'mt-3'
  }, [(!_vm.isDesktop) ? _c('div', {
    staticClass: "w-full vedio-player"
  }, [_c('VideoPlayer', {
    attrs: {
      "src": _vm.mediaGallry[_vm.isDesktop ? 'desktop' : 'mobile'].video.videoLink,
      "poster": _vm.mediaGallry[_vm.isDesktop ? 'desktop' : 'mobile'].video.poster,
      "type": 'care_page',
      "playVideo": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "halfWidth-img",
    class: _vm.isDesktop ? 'mt-3 mx-2' : 'mt-2 mx-2'
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.mediaGallry[_vm.isDesktop ? 'desktop' : 'mobile'].halfWidthImg), function(img, index) {
    return _c('div', {
      key: index,
      staticClass: "bx",
      class: 'col-' + img.col
    }, [(img.imgLink) ? _c('a', {
      attrs: {
        "href": img.imgNavigateLink || '#'
      },
      on: {
        "click": function($event) {
          _vm.preventEmptyLink(img.imgNavigateLink)
        }
      }
    }, [_c('img', {
      staticClass: "img-half-width",
      class: 'img-col-' + img.col,
      attrs: {
        "src": ((img.imgLink) + "?t=" + (new Date().getTime()))
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "padding0",
      class: 'img-description-' + img.col
    }, [_c('span', [_vm._v(_vm._s(img.imgDescription))])]), _vm._v(" "), (img.imgDescription) ? _c('div', {
      staticClass: "corusel-btn mt-3"
    }, [_c('a', {
      attrs: {
        "href": 'https://www.thesouledstore.com/artists/nomad'
      }
    }, [_c('span', [_vm._v(_vm._s('EXPLORE'))])])]) : _vm._e()])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "product-crousel-container",
    class: _vm.isDesktop ? 'mt-3' : 'mt-2 mx-1'
  }, [_c('div', {
    staticClass: "product"
  }, [_c('carousel', {
    staticClass: "bannerview",
    attrs: {
      "navigationEnabled": _vm.isDesktop,
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": false,
      "perPageCustom": [
        [480, 2],
        [768, 4],
        [1200, 4],
        [1920, 4]
      ],
      "perPage": _vm.isDesktop ? 4 : 2.5
    }
  }, _vm._l((_vm.products), function(product, productIndex) {
    return _c('slide', {
      key: productIndex,
      staticClass: "col"
    }, [_c('a', {
      attrs: {
        "href": product.productLink
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": ((product.productImg) + "?t=" + (new Date().getTime())),
        "alt": "product"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "product-name"
    }, [_vm._v(_vm._s(product.productName))])])])
  }))], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "gallry-2 mt-3",
    class: _vm.isDesktop ? 'px-2' : ''
  }, [_c('div', {
    staticClass: "halfWidth-img"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.secondGallaryImages[_vm.isDesktop ? 'desktop' : 'mobile'].halfWidthImg), function(img, index) {
    return _c('div', {
      key: index,
      staticClass: "col-6"
    }, [_c('a', {
      attrs: {
        "href": img.imgNavigateLink || '#'
      },
      on: {
        "click": function($event) {
          _vm.preventEmptyLink(img.imgNavigateLink)
        }
      }
    }, [_c('img', {
      staticClass: "img-half-width second-gal-hw-img",
      attrs: {
        "src": ((img.imgLink) + "?t=" + (new Date().getTime()))
      }
    })])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "fullwidth-img row"
  }, _vm._l((_vm.secondGallaryImages[_vm.isDesktop ? 'desktop' : 'mobile'].fullWidthImg), function(img, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-12 np"
    }, [_c('a', {
      staticClass: "d-inline-block w-100",
      attrs: {
        "href": img.imgNavigateLink || '#'
      },
      on: {
        "click": function($event) {
          _vm.preventEmptyLink(img.imgNavigateLink)
        }
      }
    }, [_c('img', {
      staticClass: "img-auto second-gal-fw-img",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": ((img.imgLink) + "?t=" + (new Date().getTime())),
        "width": "1500",
        "height": "385"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "corusel-description mt-3"
    }, [_c('span', [_vm._v(_vm._s(img.imgDescription))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "listing mt-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "listing-container row mt-3"
  }, _vm._l((_vm.listingProducts), function(product, index4) {
    return _c('div', {
      key: index4,
      staticClass: "product-card col-lg-3 col-md-6 col-6 mt-1"
    }, [_c('a', {
      attrs: {
        "href": product.productLink
      }
    }, [_c('img', {
      attrs: {
        "src": ((product.productImg) + "?t=" + (new Date().getTime())),
        "alt": "product"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "product-name"
    }, [_vm._v(_vm._s(product.productName))])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listing-header"
  }, [_c('p', [_vm._v("SHOP PHASE 1")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f32ebe6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nomad.vue
// module id = 903
// module chunks = 113